import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { WhatIsHappendResolver } from './what-is-happend/_resolvers/what-is-happend.resolver';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: { news: WhatIsHappendResolver }
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class HomeRoutingModule { }
